import React from 'react';
import {createRoot} from 'react-dom/client';
import JshModule from '@core/scripts/helper/jsh-module';
import LastSeenProducts from '@personalization/scripts/components/last-seen-products/LastSeenProducts';

const {moduleScope} = JshModule('personalization/last-seen-products');

if (moduleScope) {
    createRoot(moduleScope).render(<LastSeenProducts />);
}
